import React from "react";
import "./About.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const BASE =
  "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public";

const teamMembers = [
  {
    name: "Tithi Gautam Tewari",
    position: "Founder and MD",
    image: `${BASE}/team/Tithii.webp`,
  },
  {
    name: "Gautam Tewari",
    position: "Co-Founder & CPO",
    image: `${BASE}/team/gautam.webp`,
  },
  {
    name: "Shamima Nadia",
    position: "Chief of Staff",
    image: `${BASE}/team/nadiaa.png`,
  },
  {
    name: "Vikas Sharma",
    position: "Head - Finance and Taxation",
    image: `${BASE}/team/vikasji.webp`,
  },
  {
    name: "Mukesh Jain",
    position: "Head - Projects",
    image: `${BASE}/team/mk.png`,
  },
  {
    name: "Disha Singh",
    position: "Head - Design and Business Growth",
    image: `${BASE}/team/disha.png`,
  },
  {
    name: "Deepak Mani Tiwari",
    position: "Head - Procurement and Costing",
    image: `${BASE}/team/deepaktiwari.png`,
  },
  {
    name: "Naveen Vashisht",
    position: "Project Manager",
    image: `${BASE}/team/nav.png`,
  },
  {
    name: "Rafique Alam",
    position: "Principal - Cost Consulting",
    image: `${BASE}/team/RafiqueAlam.jpg`,
  },
  {
    name: "Sejal Agarwal",
    position: "Associate Interior Designer",
    image: `${BASE}/team/sejal.png`,
  },
  {
    name: "Sarita Yadav",
    position: "Architect",
    image: `${BASE}/team/sarita.jpg`,
  },
  {
    name: "Arpan Panikulam",
    position: "Interior Designer",
    image: `${BASE}/team/ar.jpeg`,
  },
  {
    name: "Devesh Kumar",
    position: "Project Manager",
    image: `${BASE}/dev.png`,
  },
];

const About = () => {
  return (
    <>
      <Navbar />

      <div className="about-page">
        <section className="team-section">
          {/* Background Video */}
          <video className="bg-video" autoPlay loop muted playsInline>
            <source src={`${BASE}/backvid.mp4`} type="video/mp4" />
          </video>

          <div className="team-content">
            <h2 className="team-heading">Our Team</h2>

            <div className="team-card-container">
              {teamMembers.map((member, index) => (
                <div className="team-card" key={index}>
                  <div
                    className="team-image"
                    style={{
                      backgroundImage: `url(${member.image})`,
                    }}
                  />
                  <div className="team-info">
                    <h4>{member.name}</h4>
                    <p>{member.position}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default About;